/**
 * @file   src\mobile\components\ReceiveIntroduction\ExpiredModal.js
 * @brief  This file is responsible for showing introduction expired popup.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { Modal } from "react-bootstrap";
import { pageURLs } from "@/constants";
import { useNavigate } from "react-router-dom";

const ExpiredModal = (props) => {
  const { show, onHide } = props;
  const navigate = useNavigate();
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup not-fit-modal"
    >
      <Modal.Body className="text-center">
        <h3>Introduction Expired</h3>
        <p>
          Your opportunity to initiate a conversation related to this
          introduction has expired.{" "}
        </p>
        <div className="btn-wrap">
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={() => navigate(pageURLs.mobileHome)}
          >
            Close
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ExpiredModal;
